<template>
    <div class="tab-ne-template-message-form">
        <div class="header">
            <div class="title">{{ $t('whatsapp_business_api.createNewTemplate') }}</div>

            <div class="d-flex gap-5">
                <a-button type="primary" @click="viewTemplates" ghost>
                    <a-icon type="back" />
                    {{ $t('whatsapp_business_api.viewTemplates') }}
                </a-button>
            </div>
        </div>

        <div class="inputs">
            <div class="input-wrapper">
                <div class="input-header">
                    <label>
                        {{ $t('whatsapp_business_api.templateName') }}
                        <span class="required">{{ $t('message.required') }}</span>
                    </label>
                    <a-icon type="question-circle" />
                </div>
                <span class="description">{{ $t('whatsapp_business_api.templateNameDesc') }} </span>
                <a-input v-model="form.elementName" />
                <span class="input-desc">
                    {{ $t('whatsapp_business_api.templateNameRules') }}
                </span>
            </div>
            <div class="input-wrapper">
                <div class="input-header">
                    <label>
                        {{ $t('whatsapp_business_api.category') }}
                        <span class="required">{{ $t('message.required') }}</span>
                    </label>
                    <a-icon type="question-circle" />
                </div>
                <span class="description">{{ $t('whatsapp_business_api.categoryDesc') }}</span>
                <div class="categories">
                    <div
                        class="category"
                        v-for="category of categories"
                        :key="category.id"
                        @click="form.category = category.id"
                    >
                        <div class="category-header">
                            <div class="left">
                                <span class="material-icons" v-if="form.category === category.id">
                                    radio_button_checked
                                </span>
                                <span class="material-icons" v-else> radio_button_unchecked </span>
                                <span class="label">{{ category.label }}</span>
                            </div>
                            <div class="right">
                                <span class="material-icons"> {{ category.icon }} </span>
                            </div>
                        </div>
                        <div class="category-description">
                            {{ category.description }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="input-wrapper">
                <div class="input-header">
                    <label>
                        {{ $t('settings.language') }}
                        <span class="required">{{ $t('message.required') }}</span>
                    </label>
                    <a-icon type="question-circle" />
                </div>
                <span class="description">{{ $t('whatsapp_business_api.languageDesc') }}</span>
                <a-select v-model="form.languageCode" style="width: 100%">
                    <a-select-option v-for="language of languages" :key="language.code" :value="language.code">
                        {{ language.label }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="input-wrapper">
                <div class="input-header">
                    <label>
                        {{ $t('whatsapp_business_api.header') }}
                        <span class="optional">{{ $t('whatsapp_business_api.optional') }}</span>
                    </label>
                    <a-icon type="question-circle" />
                </div>
                <span class="description">
                    {{ $t('whatsapp_business_api.headerRules') }}
                </span>

                <div class="d-flex gap-10">
                    <label style="width: 100px">{{ $t('whatsapp_business_api.headerType') }}</label>
                    <a-select v-model="form.templateType" style="width: 100%">
                        <a-select-option
                            v-for="templateType of templateTypes"
                            :key="templateType.id"
                            :value="templateType.id"
                        >
                            {{ templateType.label }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="d-flex gap-10" v-if="form.templateType === 'TEXT'">
                    <label style="width: 100px">{{ $t('whatsapp_business_api.headerText') }}</label>
                    <a-input v-model="form.header" :placeholder="$t('whatsapp_business_api.header')" />
                </div>

                <div class="input-footer d-flex flex-end" v-if="form.templateType === 'TEXT'">
                    <div class="counter">
                        <span>{{ (form.header || "").length }}</span>
                        <span>/</span>
                        <span>60</span>
                    </div>
                </div>
            </div>
            <div class="input-wrapper">
                <div class="input-header">
                    <label>
                        {{ $t('whatsapp_business_api.body') }}
                        <span class="required">{{ $t('message.required') }}</span>
                    </label>
                    <a-icon type="question-circle" />
                </div>
                <span class="description">{{ $t('whatsapp_business_api.bodyRules') }}.</span>
                <a-textarea v-model="form.content" />

                <div class="input-footer">
                    <a-button type="primary" @click="addVariable" ghost>
                        <a-icon type="plus" />
                        {{ $t('whatsapp_business_api.addVariable') }}
                    </a-button>
                    <div class="counter">
                        <span>{{ form.content.length }}</span>
                        <span>/</span>
                        <span>1024</span>
                    </div>
                </div>
                <a-divider />
                <div class="variables-container" v-if="bodyVariables.length">
                    <div class="labels">
                        <label>{{ $t('whatsapp_business_api.variables') }}</label>
                        <label id="labelSecond">{{ $t('whatsapp_business_api.defaultVariableName') }}</label>
                        <a-icon type="question-circle"
                                style="cursor: default;"
                                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                :content="$t('whatsapp_business_api.defaultVariableToolTip')"/>
                    </div>


                    <div class="variables">
                        <div class="variable" v-for="(variable, i) of bodyVariables">
                            <a-input v-model="bodyVariables[i].variable" :placeholder="$t('whatsapp_business_api.variable')" :disabled="true" />
                            <a-input v-model="bodyVariables[i].example" :placeholder="$t('whatsapp_business_api.example')" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="input-wrapper">
                <div class="input-header">
                    <label>
                        {{ $t('whatsapp_business_api.footer') }}
                        <span class="optional">{{ $t('whatsapp_business_api.optional') }}</span>
                    </label>
                    <a-icon type="question-circle" />
                </div>
                <span class="description">
                    {{ $t('whatsapp_business_api.footerDesc') }}
                </span>
                <a-input v-model="form.footer" placeholder="Footer" />

                <div class="input-footer">
                    <div class="counter">
                        <span>{{ (form.footer || "").length }}</span>
                        <span>/</span>
                        <span>60</span>
                    </div>
                </div>
            </div>
            <div class="input-wrapper">
                <div class="input-header">
                    <label>
                        {{ $t('whatsapp_business_api.buttons') }}
                        <span class="optional">{{ $t('whatsapp_business_api.optional') }}</span>
                    </label>
                    <a-icon type="question-circle" />
                </div>

                <div class="d-flex gap-10">
                    <label style="width: 100px">{{ $t('whatsapp_business_api.buttonType') }}</label>
                    <a-select v-model="form.buttonType" style="width: 100%">
                        <a-select-option v-for="buttonType of buttonTypes" :key="buttonType.id" :value="buttonType.id">
                            {{ buttonType.label }}
                        </a-select-option>
                    </a-select>
                </div>
                <a-divider />
                <div class="d-flex flex-column gap-10" v-if="form.buttonType !== 'NONE'">
                    <div class="input-footer">
                        <a-button type="primary" @click="addButton" ghost :disabled="form.buttons.length >= 3">
                            <a-icon type="plus" />
                            {{ $t('whatsapp_business_api.addButton') }}
                        </a-button>
                        <div class="counter">
                            <span>{{ form.buttons.length }}</span>
                            <span>/</span>
                            <span>3</span>
                        </div>
                    </div>
                    <div class="button-container">
                        <label>{{ $t('whatsapp_business_api.buttons') }}</label>
                        <div class="buttons">
                            <div class="button" v-for="(button, i) of form.buttons">
                                <strong> {{ i + 1 }}. Button ==> </strong>
                                <a-input v-model="form.buttons[i].text" placeholder="Button1" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="actions d-flex flex-end w-100">
                <a-button type="primary" @click="submit" :disabled="submitting">
                    <a-icon type="save" />
                    {{ submitting ? $t('whatsapp_business_api.submitting') : $t('whatsapp_business_api.submit') }}
                </a-button>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import WABusinessMenuTypes from "../WABusinessMenuTypes";
import log2 from "../../../../../utils/log2";
import { sendSocketMessage, socketMessageStream } from "../../../../../utils/socketStream";

const log = log2("TemplateMessageForm.vue");
export default Vue.extend({
    name: "TemplateMessageForm",
    props: {
        channel: {
            required: true,
        },
        changePage: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            templateTypes: [
                {
                    id: "none",
                    label: this.$t('whatsapp_business_api.none'),
                },
                {
                    id: "TEXT",
                    label: this.$t('whatsapp_business_api.headerOptionText'),
                },
                {
                    id: "MEDIA",
                    label: this.$t('whatsapp_business_api.headerOptionMedia'),
                },
            ],
            buttonTypes: [
                {
                    id: "none",
                    label: this.$t('whatsapp_business_api.none'),
                },
                {
                    id: "QUICK_REPLY",
                    label: this.$t('whatsapp_business_api.buttonTypeReply'),
                },
                // {
                //     id: "CALL_TO_ACTION",
                //     label: "Call to Action",
                // },
            ],
            categories: [
                {
                    id: "UTILITY",
                    label: this.$t("whatsapp_business_api.categoryUtility"),
                    description: this.$t('whatsapp_business_api.categoryUtilityDesc'),
                    icon: "work",
                },
                {
                    id: "MARKETING",
                    label: this.$t('whatsapp_business_api.categoryMarketing'),
                    description: this.$t('whatsapp_business_api.categoryMarketingDesc'),
                    icon: "campaign",
                },
                {
                    id: "AUTHENTICATION",
                    label: this.$t('whatsapp_business_api.categoryAuth'),
                    description: this.$t('whatsapp_business_api.categoryAuthDesc'),
                    icon: "password",
                },
            ],
            languages: [
                { label: "Afrikaans", code: "af" },
                { label: "Albanian", code: "sq" },
                { label: "Arabic", code: "ar" },
                { label: "Azerbaijani", code: "az" },
                { label: "Bengali", code: "bn" },
                { label: "Bulgarian", code: "bg" },
                { label: "Catalan", code: "ca" },
                { label: "Chinese (CHN)", code: "zh_CN" },
                { label: "Chinese (HKG)", code: "zh_HK" },
                { label: "Chinese (TAI)", code: "zh_TW" },
                { label: "Croatian", code: "hr" },
                { label: "Czech", code: "cs" },
                { label: "Danish", code: "da" },
                { label: "Dutch", code: "nl" },
                { label: "English", code: "en" },
                { label: "English (UK)", code: "en_GB" },
                { label: "English (US)", code: "en_US" },
                { label: "Estonian", code: "et" },
                { label: "Filipino", code: "fil" },
                { label: "Finnish", code: "fi" },
                { label: "French", code: "fr" },
                { label: "Georgian", code: "ka" },
                { label: "German", code: "de" },
                { label: "Greek", code: "el" },
                { label: "Gujarati", code: "gu" },
                { label: "Hausa", code: "ha" },
                { label: "Hebrew", code: "he" },
                { label: "Hindi", code: "hi" },
                { label: "Hungarian", code: "hu" },
                { label: "Indonesian", code: "id" },
                { label: "Irish", code: "ga" },
                { label: "Italian", code: "it" },
                { label: "Japanese", code: "ja" },
                { label: "Kannada", code: "kn" },
                { label: "Kazakh", code: "kk" },
                { label: "Kinyarwanda", code: "rw_RW" },
                { label: "Korean", code: "ko" },
                { label: "Kyrgyz (Kyrgyzstan)", code: "ky_KG" },
                { label: "Lao", code: "lo" },
                { label: "Latvian", code: "lv" },
                { label: "Lithuanian", code: "lt" },
                { label: "Macedonian", code: "mk" },
                { label: "Malay", code: "ms" },
                { label: "Malayalam", code: "ml" },
                { label: "Marathi", code: "mr" },
                { label: "Norwegian", code: "nb" },
                { label: "Persian", code: "fa" },
                { label: "Polish", code: "pl" },
                { label: "Portuguese (BR)", code: "pt_BR" },
                { label: "Portuguese (POR)", code: "pt_PT" },
                { label: "Punjabi", code: "pa" },
                { label: "Romanian", code: "ro" },
                { label: "Russian", code: "ru" },
                { label: "Serbian", code: "sr" },
                { label: "Slovak", code: "sk" },
                { label: "Slovenian", code: "sl" },
                { label: "Spanish", code: "es" },
                { label: "Spanish (ARG)", code: "es_AR" },
                { label: "Spanish (SPA)", code: "es_ES" },
                { label: "Spanish (MEX)", code: "es_MX" },
                { label: "Swahili", code: "sw" },
                { label: "Swedish", code: "sv" },
                { label: "Tamil", code: "ta" },
                { label: "Telugu", code: "te" },
                { label: "Thai", code: "th" },
                { label: "Turkish", code: "tr" },
                { label: "Ukrainian", code: "uk" },
                { label: "Urdu", code: "ur" },
                { label: "Uzbek", code: "uz" },
                { label: "Vietnamese", code: "vi" },
                { label: "Zulu", code: "zu" },
            ],

            form: {
                category: "MARKETING",
                elementName: "new_campaign_1",
                languageCode: "tr",
                content: "Merhaba {{1}}, yeni ürünlerimizden haberdar olmak ister misiniz?",
                appId: this.channel.payload.appId,
                templateType: "TEXT",
                buttonType: this.$t('whatsapp_business_api.none'),
                vertical: "new_campaign_1",
                example: "",
                allowTemplateCategoryChange: true,
                checkerApprovalRequired: false,
                enableSample: false,
                buttons: [],
                header: "",
                exampleHeader: null,
                footer: "İletişim için teşekkürler",
            },
            bodyVariables: [],
            submitting: false,
        };
    },
    methods: {
        checkIsValid() {
            //todo check form valid
            return true;
        },
        getExampleBodyContent() {
            const content = this.form.content;
            const variables = this.bodyVariables;
            const example = content.replace(/{{\d}}/g, function (match) {
                const index = match.replace(/{{/g, "").replace(/}}/g, "");
                return `[${variables[index - 1].example}]`;
            });
            return example;
        },
        listenSocketMessages() {
            this.subscriber = socketMessageStream.subscribe((message) => {
                if (message.cmd === "whatsapp_create_template_message_response") {
                    log("whatsapp_create_template_message_response =>", message);
                    this.submitting = false;
                    if (!!message.data.response) {
                        this.$message.success("Template message created successfully");
                        this.viewTemplates();
                    } else {
                        this.$message.error("Failed to create template message");
                    }
                }
            });
        },

        submit() {
            if (this.checkIsValid()) {
                this.submitting = true;
                const templateMessage = {
                    category: this.form.category,
                    elementName: this.form.elementName,
                    languageCode: this.form.languageCode,
                    content: this.form.content,
                    appId: this.form.appId,
                    templateType: this.form.templateType === "none" ? "TEXT" : this.form.templateType,
                    vertical: this.form.elementName,
                    example: this.getExampleBodyContent(),
                    allowTemplateCategoryChange: this.form.allowTemplateCategoryChange,
                    checkerApprovalRequired: this.form.checkerApprovalRequired,
                    enableSample: this.form.enableSample,
                    buttons: this.form.buttons.length ? this.form.buttons : null,
                    header: (this.form.header || "").length ? this.form.header : null,
                    exampleHeader: (this.form.header || "").length ? this.form.header : null,
                    footer: (this.form.footer || "").length ? this.form.footer : null,
                };
                sendSocketMessage("whatsapp create-template-message", {
                    siteId: this.channel.siteId,
                    channelId: this.channel._id,
                    templateMessage,
                });
                this.$message.loading("Template message creating ,please wait...", 3);
            }
        },
        viewTemplates() {
            log("viewTemplates");
            this.changePage(WABusinessMenuTypes.TEMPLATE_MESSAGE_LIST.id);
        },

        addVariable() {
            if (this.bodyVariables.length >= 5) {
                this.$message.error("You can add up to 5 variables");
            } else {
                this.bodyVariables.push({
                    variable: `{{${this.bodyVariables.length + 1}}}`,
                    example: "",
                });
                this.form.content += `{{${this.bodyVariables.length}}}`;
            }
        },
        addButton() {
            if (this.form.buttons.length < 3) {
                this.form.buttons.push({
                    type: "QUICK_REPLY",
                    text: `Button ${this.form.buttons.length + 1}`,
                });
            }
        },
        findBodyVariables() {
            const regex = /{{\d}}/g;
            const matches = _.uniq(this.form.content.match(regex));
            log("findBodyVariables=>", matches);
            if (matches) {
                const getValue = (variable) => this.bodyVariables.find((x) => x.variable === variable)?.example || "";
                this.bodyVariables = matches.map((x, i) => {
                    return {
                        variable: x,
                        example: getValue(x),
                    };
                });
            }
        },
    },
    mounted() {
        this.listenSocketMessages();
    },
    beforeDestroy() {
        this.subscriber.unsubscribe();
    },

    watch: {
        form: {
            handler: function (newValue, oldValue) {
                if (!!newValue) {
                    this.findBodyVariables();
                }
            },
            deep: true,
            immediate: true,
        },
    },
});
</script>

<style scoped lang="scss">
.tab-ne-template-message-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--color-border-default);
        border-radius: 4px;

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }

    .inputs {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 10px;
            border: 1px solid var(--color-border-default);

            .input-header {
                display: flex;
                justify-content: space-between;
                align-items: center;

                label {
                    font-size: 18px;
                    font-weight: 700;
                    color: var(--color-text-strong-default);
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    padding-right: 20px;
                }

                .optional {
                    font-size: 12px;
                    font-weight: 400;
                    color: var(--color-text-low-default);
                    background: var(--color-bg-neutral-default);
                    padding: 2px 5px;
                }

                .required {
                    font-size: 12px;
                    font-weight: 400;
                    color: var(--color-text-onprimary-default);
                    background: var(--color-bg-critical-default);
                    padding: 2px 5px;
                }
            }

            .description {
                color: var(--color-text-low-default);
                font-size: 14px;
            }

            .input-desc {
                color: var(--color-text-low-default);
                font-size: 12px;
            }

            .categories {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 20px;

                .category {
                    margin: 0;
                    width: 300px;
                    height: 115px;
                    padding: 20px;
                    align-items: flex-start;
                    position: relative;
                    background: #f9fafb;
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                    cursor: pointer;

                    .category-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        .left {
                            display: flex;
                            gap: 5px;
                            align-items: center;
                            width: 100%;

                            .label {
                                font-size: 14px;
                                font-weight: 700;
                                color: var(--color-text-strong-default);
                            }
                        }

                        .right {
                            width: 100%;
                            display: flex;
                            justify-content: flex-end;
                            align-items: center;
                        }
                    }

                    .category-description {
                        font-size: 12px;
                        color: var(--color-text-low-default);
                    }
                }
            }

            .input-footer {
                display: flex;
                justify-content: space-between;
            }

            .variables-container {
                display: flex;
                flex-direction: column;
                gap: 5px;
                width: 66%;
                .labels{
                    width: 100%;
                    display: flex;
                    #labelSecond{
                        margin-left: 40%;
                        margin-right: 8px;
                    }
                }
                label {
                    font-size: 14px;
                    font-weight: 700;
                    color: var(--color-text-strong-default);
                }

                .variables {
                    display: flex;
                    flex-direction: column;
                    gap: 5px;

                    .variable {
                        display: flex;
                        gap: 20px;
                    }
                }
            }

            .button-container {
                display: flex;
                flex-direction: column;
                gap: 5px;
                width: 66%;

                label {
                    font-size: 14px;
                    font-weight: 700;
                    color: var(--color-text-strong-default);
                }

                .buttons {
                    display: flex;
                    flex-direction: column;
                    gap: 5px;

                    .button {
                        display: flex;
                        gap: 20px;
                        align-items: center;

                        input {
                            width: 80%;
                        }
                    }
                }
            }
        }
    }
}
</style>
